import { render, staticRenderFns } from "./SessionsManager.vue?vue&type=template&id=345d2530&"
import script from "./SessionsManager.vue?vue&type=script&lang=js&"
export * from "./SessionsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports